import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store from "../../../../store";
import { setRendererFormState } from "../../../../store/slices/commonSlice";

const Email = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <input
          id={newElfromJSON}
          className="form-control"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          type="email"
          placeholder={fieldEle?.["display-placeholder"]}
          required={fieldEle?.["display-required"] === 1}
          disabled={fieldEle?.["display-disabled"] === 1}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          pattern={fieldEle?.["validation-pattern"]}
          name={key}
          value={formState[key] || ""}
          onChange={(e) => {
            if (fieldEle?.["validation-pattern"]) {
              let inputValue = e.target.value;
              let pattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

              if (!pattern.test(inputValue)) {
                e.target.setCustomValidity(
                  "Please enter a valid email address."
                );
              } else {
                e.target.setCustomValidity("");
              }
            }
            store.dispatch(
              setRendererFormState({ key, value: e.target.value })
            );
          }}
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Email;
